import React from 'react';
import { FileText, Clock, CheckCircle2, DollarSign } from 'lucide-react';
export function MyBookings() {
  const bookings = [{
    id: 'BQ-8492',
    group: 'Smith-Johnson Wedding',
    property: 'Moon Palace Cancún',
    dates: 'Oct 12 - Oct 16, 2026',
    rooms: 45,
    value: 125000,
    status: 'Hold Active'
  }, {
    id: 'BQ-8488',
    group: 'Yoga Wellness Retreat',
    property: 'Le Blanc Spa Resort Los Cabos',
    dates: 'Jan 15 - Jan 20, 2027',
    rooms: 25,
    value: 145000,
    status: 'Quote Received'
  }, {
    id: 'BQ-8450',
    group: 'TechCorp Retreat',
    property: 'The Grand at Moon Palace',
    dates: 'Nov 05 - Nov 09, 2026',
    rooms: 120,
    value: 480000,
    status: 'Contract Signed'
  }, {
    id: 'BQ-8412',
    group: 'Williams Reunion',
    property: 'Moon Palace Jamaica',
    dates: 'Dec 20 - Dec 27, 2026',
    rooms: 15,
    value: 85000,
    status: 'Completed'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Contract Signed':
        return 'bg-emerald-100 text-emerald-700 border-emerald-200';
      case 'Hold Active':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      case 'Quote Received':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'Completed':
        return 'bg-stone-100 text-stone-700 border-stone-200';
      default:
        return 'bg-stone-100 text-stone-700 border-stone-200';
    }
  };
  return <div className="space-y-8 animate-in fade-in duration-500 pb-24" data-id="element-212">
      <div data-id="element-213">
        <h1 className="font-serif text-3xl md:text-4xl text-stone-900 mb-2" data-id="element-214">
          My Bookings
        </h1>
        <p className="text-stone-500" data-id="element-215">
          Manage your agency's group quotes, holds, and contracts.
        </p>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-216">
        <div className="bg-white p-6 border border-stone-200 rounded-xl shadow-sm flex items-center gap-4" data-id="element-217">
          <div className="p-3 bg-blue-50 text-blue-600 rounded-lg" data-id="element-218">
            <FileText className="w-6 h-6" data-id="element-219" />
          </div>
          <div data-id="element-220">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-1" data-id="element-221">
              Active Quotes
            </p>
            <p className="font-mono text-2xl text-stone-900" data-id="element-222">3</p>
          </div>
        </div>
        <div className="bg-white p-6 border border-stone-200 rounded-xl shadow-sm flex items-center gap-4" data-id="element-223">
          <div className="p-3 bg-amber-50 text-amber-600 rounded-lg" data-id="element-224">
            <Clock className="w-6 h-6" data-id="element-225" />
          </div>
          <div data-id="element-226">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-1" data-id="element-227">
              Holds Expiring
            </p>
            <p className="font-mono text-2xl text-stone-900" data-id="element-228">1</p>
          </div>
        </div>
        <div className="bg-white p-6 border border-stone-200 rounded-xl shadow-sm flex items-center gap-4" data-id="element-229">
          <div className="p-3 bg-emerald-50 text-emerald-600 rounded-lg" data-id="element-230">
            <CheckCircle2 className="w-6 h-6" data-id="element-231" />
          </div>
          <div data-id="element-232">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-1" data-id="element-233">
              Contracted
            </p>
            <p className="font-mono text-2xl text-stone-900" data-id="element-234">5</p>
          </div>
        </div>
        <div className="bg-white p-6 border border-stone-200 rounded-xl shadow-sm flex items-center gap-4" data-id="element-235">
          <div className="p-3 bg-stone-100 text-stone-600 rounded-lg" data-id="element-236">
            <DollarSign className="w-6 h-6" data-id="element-237" />
          </div>
          <div data-id="element-238">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-1" data-id="element-239">
              Total Value
            </p>
            <p className="font-mono text-2xl text-stone-900" data-id="element-240">$1.2M</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white border border-stone-200 rounded-xl shadow-sm overflow-hidden" data-id="element-241">
        <div className="overflow-x-auto" data-id="element-242">
          <table className="w-full text-left text-sm" data-id="element-243">
            <thead className="bg-stone-50 border-b border-stone-200" data-id="element-244">
              <tr data-id="element-245">
                <th className="p-4 font-mono text-xs uppercase tracking-widest text-stone-500 font-medium" data-id="element-246">
                  ID
                </th>
                <th className="p-4 font-mono text-xs uppercase tracking-widest text-stone-500 font-medium" data-id="element-247">
                  Group Name
                </th>
                <th className="p-4 font-mono text-xs uppercase tracking-widest text-stone-500 font-medium" data-id="element-248">
                  Property
                </th>
                <th className="p-4 font-mono text-xs uppercase tracking-widest text-stone-500 font-medium" data-id="element-249">
                  Dates & Rooms
                </th>
                <th className="p-4 font-mono text-xs uppercase tracking-widest text-stone-500 font-medium" data-id="element-250">
                  Value
                </th>
                <th className="p-4 font-mono text-xs uppercase tracking-widest text-stone-500 font-medium" data-id="element-251">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100" data-id="element-252">
              {bookings.map(booking => <tr key={booking.id} className="hover:bg-stone-50 cursor-pointer transition-colors group" data-id="element-253">
                  <td className="p-4 font-mono text-stone-500 group-hover:text-red-600 transition-colors" data-id="element-254">
                    {booking.id}
                  </td>
                  <td className="p-4 font-medium text-stone-900" data-id="element-255">
                    {booking.group}
                  </td>
                  <td className="p-4 text-stone-600" data-id="element-256">{booking.property}</td>
                  <td className="p-4" data-id="element-257">
                    <p className="text-stone-900" data-id="element-258">{booking.dates}</p>
                    <p className="text-stone-500" data-id="element-259">{booking.rooms} rooms</p>
                  </td>
                  <td className="p-4 font-mono text-stone-900" data-id="element-260">
                    ${booking.value.toLocaleString()}
                  </td>
                  <td className="p-4" data-id="element-261">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-mono border ${getStatusColor(booking.status)}`} data-id="element-262">
                      {booking.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}